import React from 'react';
import IconLoading from '../_Icons/IconLoaderClock';
import styles from './Loader.scss';

const Loader = () => <IconLoading className={styles.root} />;
export default Loader;
